export const projectColumns = [
    { id: 'name', Header: 'Cell name' },
    { id: 'createdAt', Header: 'Date created' },
    { id: 'statsAndExport', Header: 'Stats and export' },
    // { id: 'json', Header: 'JSON file' },
    { id: 'actions', Header: 'Actions' },
];
